<template>
  <div>
    <van-tabbar v-model="active" active-color="#9a7d4a">
      <van-tabbar-item
        v-for="(item,index) in list"
        :key="index"
        :to="item.path"
        :class="item.icon"
      >{{item.name}}</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import { constants } from "crypto";
export default {
  name: "Tabbar",
  data() {
    return {
      active: 0,
      replace: true,
      list: [
        {
          name: "首页",
          icon: "iconfont iconshouye ic",
          path: "/"
        },
        {
          name: "分类",
          icon: "iconfont iconfenlei ic",
          path: "/category"
        },
        {
          name: "现货",
          icon: "iconfont icondaishouhuo1 ic",
          path: "/cash"
        },
        {
          name: "视频",
          icon: "iconfont iconshipin ic",
          path: "/video"
        },
        {
          name: "我的",
          icon: "iconfont iconwode ic",
          path: "/my"
        }
      ]
    };
  },
  created() {
    let arr = ["/", "/category", "/cash","/video", "/my"];
    if (arr.indexOf(this.$route.path) > -1) {
      this.active = arr.indexOf(this.$route.path);
    }
  },
  mounted() {},
  activated() {
    let arr = ["/", "/category", "/cash","/video", "/my"];
    if (arr.indexOf(this.$route.path) > -1) {
      this.active = arr.indexOf(this.$route.path);
    }
  },
  methods: {}
};
</script>
<style>
.iconfont {
  width: 28px;
  font-size: 26px;
  line-height: 25px;
}
.ic {
  color: #888888;
}
.van-tabbar-item__text {
  /* height: 11px; */
  line-height: 11px;
  font-size: 11px;
}
.van-hairline--top-bottom {
  height: 51px;
}
</style>